import { ContentState } from 'draft-js';

import beautifyField from './beautifyField';
import removeEmptyBlocks from '../draft-js/modifiers/removeEmptyBlocks';

export default function cleanUpBlocks(content) {
  return content.map(block => block.map(field => (
    field instanceof ContentState ? removeEmptyBlocks(beautifyField(field)) : field
  )));
}
